<template>
	<div class="colHalf rubricTable">
		<div class="row between rubricAverage">
			<span>{{question.question}}</span>
			<span>{{parseInt(question.percentage)}}%</span>
		</div>
		<div class="row center">
			<table :class="`table table-striped table cat${categoryId}`">
			<thead>
				<tr>
					<th scope="col">Nivel</th>
					<th scope="col">Promedio</th>
					<th scope="col">Español</th>
					<th scope="col">Inglés</th>
				</tr>
			</thead>
			<tbody>
				<tr v-if="preSchool">
					<th scope="row">Preescolar</th>
					<td>{{parseInt(preSchool.average)}}%</td>
					<td v-if="preSchool.spanishPercentage">{{parseInt(preSchool.spanishPercentage)}}%</td>
					<td v-else>Sin datos</td>
					<td v-if="preSchool.englishPercentage">{{parseInt(preSchool.englishPercentage)}}%</td>
					<td v-else>Sin datos</td>
				</tr>
				<tr v-if="primary">
					<th scope="row">Primaria</th>
					<td>{{parseInt(primary.average)}}%</td>
					<td v-if="primary.spanishPercentage">{{parseInt(primary.spanishPercentage)}}%</td>
					<td v-else>Sin datos</td>
					<td v-if="primary.englishPercentage">{{parseInt(primary.englishPercentage)}}%</td>
					<td v-else>Sin datos</td>
				</tr>
				<tr v-if="highSchool">
					<th scope="row">Secundaria</th>
					<td>{{parseInt(highSchool.average)}}%</td>
					<td v-if="highSchool.spanishPercentage">{{parseInt(highSchool.spanishPercentage)}}%</td>
					<td v-else>Sin datos</td>
					<td v-if="highSchool.englishPercentage">{{parseInt(highSchool.englishPercentage)}}%</td>
					<td v-else>Sin datos</td>
				</tr>
			</tbody>
		</table>
		</div>
	</div>
</template>

<script>
export default {
	props: ['question', 'categoryId'],
	computed: {
		preSchool () {
			return this.getLevel('Preescolar');
		},
		primary () {
			return this.getLevel('Primaria');
		},
		highSchool () {
			return this.getLevel('Secundaria');
		}
	},
	methods: {
		getLevel (academicLevelName) {
			let academicLevel = this.question.academicLevels.find((academicLevel) => {
				return academicLevel.name == academicLevelName;
			});
			if (!academicLevel) return academicLevel;
			academicLevel.average = academicLevel.percentage;
			academicLevel.spanishPercentage = this.getLanguagePercentage(academicLevel, 'es');
			academicLevel.englishPercentage = this.getLanguagePercentage(academicLevel, 'en');
			return academicLevel;
		},
		getLanguagePercentage (academicLevel, languageId) {
			let language = academicLevel.languages.find((language) => {
				return language.id == languageId;
			});
			if (!language) return language;
			return language.percentage;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";

.table {
	&.cat1 {
		background-color: $blank;
		border-radius: 0.4rem;
		overflow: hidden;
		& tbody {
			border: 0.2rem solid $liteGrey2;
			border-radius: 0.2rem;
			overflow: hidden;
		}
		& thead tr th {
			border: none;
			border-bottom: 0.5rem solid $cat1;
		}
		& tbody tr th,
		& tbody tr td {
			border: 0.1rem solid $blank;
		}
		& tbody tr:nth-child(odd) {
			background-color: $liteGrey3;
		}
		& tbody tr:nth-child(even) {
			background-color: rgba($cat1, 0.15);
		}
	}
	&.cat2 {
		background-color: $blank;
		border-radius: 0.4rem;
		overflow: hidden;
		& tbody {
			border: 0.2rem solid $liteGrey2;
			border-radius: 0.2rem;
			overflow: hidden;
		}
		& thead tr th {
			border: none;
			border-bottom: 0.5rem solid $cat2;
		}
		& tbody tr th,
		& tbody tr td {
			border: 0.1rem solid $blank;
		}
		& tbody tr:nth-child(odd) {
			background-color: $liteGrey3;
		}
		& tbody tr:nth-child(even) {
			background-color: rgba($cat2, 0.15);
		}
	}
	&.cat3 {
		background-color: $blank;
		border-radius: 0.4rem;
		overflow: hidden;
		& tbody {
			border: 0.2rem solid $liteGrey2;
			border-radius: 0.2rem;
			overflow: hidden;
		}
		& thead tr th {
			border: none;
			border-bottom: 0.5rem solid $cat3;
		}
		& tbody tr th,
		& tbody tr td {
			border: 0.1rem solid $blank;
		}
		& tbody tr:nth-child(odd) {
			background-color: $liteGrey3;
		}
		& tbody tr:nth-child(even) {
			background-color: rgba($cat3, 0.15);
		}
	}
	&.cat4 {
		background-color: $blank;
		border-radius: 0.4rem;
		overflow: hidden;
		& tbody {
			border: 0.2rem solid $liteGrey2;
			border-radius: 0.2rem;
			overflow: hidden;
		}
		& thead tr th {
			border: none;
			border-bottom: 0.5rem solid $cat4;
		}
		& tbody tr th,
		& tbody tr td {
			border: 0.1rem solid $blank;
		}
		& tbody tr:nth-child(odd) {
			background-color: $liteGrey3;
		}
		& tbody tr:nth-child(even) {
			background-color: rgba($cat4, 0.15);
		}
	}
}

.rubric {
		padding: 0 1rem;
		margin: 0.5rem 0;
		align-items: flex-start;
		min-width: 45.6rem;
		min-height: 24.6rem;
		&Table {
			flex-wrap: wrap;
		}
		&Average {
			font-size: $bigSize;
			font-weight: 700;
			margin: 1rem 0 2rem 0;
			& > * {
				font-size: inherit;
			}
		}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/PercentagesDetail.vue